import React, {FC, useState} from "react"
import * as PropTypes from "prop-types"

import GenericModal from "@irati/ui/src/GenericModal"
import {Body, H2} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import {RecognitionRoutes} from "@irati-web/recognition/src/enums/Routes"

import {adminDashboardTracking} from "@irati-tracking/admin"
import ModalWidget from "../ModalWidget"
import RecognitionChain from "../Recognition/RecognitionChain"

interface Props {
  show: boolean
  onHide: () => void
}

const ValuesAndCelebrationsModal: FC<Props> = ({show, onHide}, {apps}) => {
  const [showRecognitionChain, setShowRecognitionChain] = useState(false)

  const handleHide = () => {
    setShowRecognitionChain(false)
    onHide()
  }

  const handleRecognitionChainClick = () => {
    adminDashboardTracking.valuesCelebrationsActions("cta_recognitionChain")
    setShowRecognitionChain(true)
  }

  return (
    <GenericModal hideActions show={show} customWidth={884} onHide={handleHide}>
      {showRecognitionChain ? (
        <RecognitionChain onClick={() => setShowRecognitionChain(false)} />
      ) : (
        <>
          <H2 marginBottom={1}>
            <FormattedMessage id="admin.components.dashboard.reporting.valuesCelebration.modal.title" />
          </H2>
          <Body marginBottom={2} maxWidth="100%">
            <FormattedMessage id="admin.components.dashboard.reporting.valuesCelebration.modal.text" />
          </Body>
          <Flex gap={1}>
            <ModalWidget
              title="admin.components.dashboard.reporting.valuesCelebration.modal.widgets.recognise.title"
              buttonText="admin.components.dashboard.reporting.valuesCelebration.modal.widgets.recognise.button"
              emoji="🎉"
              app={apps.RECOGNITION}
              link={RecognitionRoutes.CREATE_RECOGNITION}
              onClick={() => adminDashboardTracking.valuesCelebrationsActions("cta_createRecognition")}
              text="admin.components.dashboard.reporting.valuesCelebration.modal.widgets.recognise.text"
            />
            <ModalWidget
              title="admin.components.dashboard.reporting.valuesCelebration.modal.widgets.poll.title"
              buttonText="admin.components.dashboard.reporting.valuesCelebration.modal.widgets.poll.button"
              emoji="🗳️"
              app={apps.RECOGNITION}
              link={RecognitionRoutes.CREATE_POLL}
              onClick={() => adminDashboardTracking.valuesCelebrationsActions("cta_createPoll")}
              text="admin.components.dashboard.reporting.valuesCelebration.modal.widgets.poll.text"
            />
            <ModalWidget
              title="admin.components.dashboard.reporting.recognition.modal.widgets.chain.title"
              buttonText="admin.components.dashboard.reporting.recognition.modal.widgets.chain.button"
              emoji="🏆"
              onClick={handleRecognitionChainClick}
              text="admin.components.dashboard.reporting.recognition.modal.widgets.chain.text"
              isRecommended
            />
          </Flex>
        </>
      )}
    </GenericModal>
  )
}

ValuesAndCelebrationsModal.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default injectIntl(ValuesAndCelebrationsModal)
